import React, { useState, useEffect, useMemo } from "react";
import { Alert, Box, Container } from "@mui/material";

// ─── Icons ──────────────────────────────────────────────────────────────────────
import PageTitle from "../../widgets/PageTitle";
import TextMessage from "./addbots/TextMessage";
import BackBtn from "../../widgets/BackBtn";
import MediaMessage from "./addbots/MediaMessage";
import InteractiveButtonsBuilder from "./addbots/InteractiveButtonsBuilder";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SendLocation from "./addbots/SendLocation";
import SendLocationRequest from "./addbots/SendLocationRequest";
import InteractiveCtaUrls from "./addbots/InteractiveCtaUrls";
import InteractiveList from "./addbots/InteractiveList";
import EndpointMessage from "./addbots/EndpointMessage";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse } from "../../utils/util";

const typeComponentMap = {
  text: TextMessage,
  image: MediaMessage,
  document: MediaMessage,
  video: MediaMessage,
  interactive_reply_buttons: InteractiveButtonsBuilder,
  location: SendLocation,
  list: InteractiveList,
  location_request_message: SendLocationRequest,
  interactive_cta_urls: InteractiveCtaUrls,
  endpoint: EndpointMessage,
};

const EditMessages = () => {
  const { id } = useParams();
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/message/get-response/${id}`
  );

  const Component = useMemo(() => {
    return data ? typeComponentMap[data.type] : null;
  }, [data]);

  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  return (
    <Container sx={{ my: 2 }} maxWidth="md">
      <BackBtn />
      <PageTitle>Edit Message</PageTitle>
      <Box my={2}>{<Component editId={id} isEdit={true} value={data} />}</Box>
    </Container>
  );
};

export default EditMessages;
